import {
  WSButton,
  WSCard,
  WSControl,
  WSForm,
  WSIconList,
  WSInfoBox,
  WSList,
  WSSectionToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import { WSCardProps } from "@wingspanhq/fe-component-library/dist/lib/components/WSCard/WSCard";

export const FormPartialAcceptWingspanMasterPolicy: React.FC<
  WSCardProps & {
    switchLabel: string;
  }
> = ({ switchLabel, ...props }) => (
  <WSCard {...props}>
    <WSSectionToolbar title="Accept Wingspan Master Policy" />
    <WSText.ParagraphSm color="gray500">
      Contractors enrolled in Wingspan's Master Policy automatically satisfy
      this requirement. No manual review needed—verification is instant.
    </WSText.ParagraphSm>
    <WSButton.Link rightIcon="chevron-right">Learn more</WSButton.Link>

    <WSList gap="L" mt="L">
      <WSForm.Field
        name="acceptWingspanMasterPolicy"
        component={WSControl}
        componentProps={{
          type: "switch",
          label: switchLabel,
          chip: true
        }}
      />
      <WSInfoBox
        theme="neutral"
        title="This insurance is designer for:"
        icon="group"
      >
        <WSIconList
          items={["Independent Claims Adjusters"]}
          iconProps={{
            name: "check-circle",
            color: "green500"
          }}
        />
      </WSInfoBox>
      <WSInfoBox
        theme="neutral"
        title="Benefits of accepting the Master Policy:"
        icon="bulb"
      >
        <WSIconList
          items={[
            "Instant compliance verification—no COI review delays",
            "Standardized coverage you can rely on",
            "Contractors can enroll immediately if not already covered",
            "Reduces administrative burden for your team"
          ]}
          iconProps={{
            name: "check-circle",
            color: "green500"
          }}
        />
      </WSInfoBox>
      <WSText.ParagraphSm>
        <b>Note:</b> You can accept both Wingspan master policy and other
        insurance. Settings below apply only to uploaded certificates.
      </WSText.ParagraphSm>
    </WSList>
  </WSCard>
);
